import React from "react";
import { Info } from "lucide-react";

export function DisclaimerBanner() {
  return (
    <div
      data-testid="compliance-disclaimer"
      className="flex items-start gap-3 bg-navy text-slate-200 text-xs px-4 py-2.5 border-b border-white/10"
    >
      <Info className="h-4 w-4 text-gold shrink-0 mt-0.5" aria-hidden="true" />
      <p className="leading-relaxed">
        ComplyX Gov provides readiness support, documentation assistance, and assessment preparation services.
        Formal CMMC certification assessments must be conducted independently by an{" "}
        <span className="text-gold font-medium">authorized C3PAO</span>.
      </p>
    </div>
  );
}
